import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ListBrands from "../Components/Brands/listBrands";
import AddBrands from "../Components/Brands/addBrands";

const BrandsRoutes = () => {
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];

  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  // const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');
  return (
    <Routes>
      <Route path="/brands" element={<ListBrands></ListBrands>}></Route>
      <Route path="/brands/add" element={canAdd ? <AddBrands></AddBrands> : <Navigate to="/brands" replace />}></Route>
    </Routes>
  );
};

export default BrandsRoutes;
